import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSend = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M1.267 14.73a.77.77 0 0 0 .648.268q.39-.021.867-.257l11.275-5.677q.228-.119.404-.242.182-.117.306-.258A.84.84 0 0 0 15 8q0-.3-.233-.564a1.6 1.6 0 0 0-.306-.258 4 4 0 0 0-.405-.242L2.72 1.233A2 2 0 0 0 1.915 1a.77.77 0 0 0-.648.27q-.329.37-.253.79.08.413.32.919l1.791 3.784q.158.338.32.489.165.145.467.161l10.111.387q.085 0 .129.06.053.058.057.139a.19.19 0 0 1-.048.14.18.18 0 0 1-.138.059l-10.111.43a.7.7 0 0 0-.453.156q-.163.14-.334.484L1.367 12.96a4.2 4.2 0 0 0-.343.957q-.09.434.243.812"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
